import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BUTTONS, HEADINGS } from "@/utils/constants/appConstants/commonConstants";

interface AzureDirectoryInstructionProps {
    show?: boolean;
    onHide?: () => void;
}

const AzureDirectoryInstruction = (props: AzureDirectoryInstructionProps) => {
    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) props.onHide?.(); }}>
            <DialogContent className="gs-directory-info-dialog">
                <div className="gs-directory-info-dialog__header">
                    <h4 className="gs-directory-info-dialog__title" id="azure-directory-instruction-title">
                        {HEADINGS.AZURE_INSTRUCTION_HEADER}
                    </h4>
                </div>

                <div className="gs-directory-info-dialog__body">
                    <p id="azure-directory-instruction-text">
                        This is a unique identifier for your organization&apos;s Microsoft Entra ID. You can find it in the Azure portal under &apos;Azure Active Directory&apos; &gt; &apos;Properties&apos; &gt; &apos;Tenant ID&apos;.
                    </p>
                </div>

                <div className="gs-directory-info-dialog__footer">
                    <Button id="azure-directory-instruction-close-btn" onClick={props.onHide}>
                        {BUTTONS.CLOSE}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AzureDirectoryInstruction;
